import React from 'react';
import PropTypes from 'prop-types';

import NatureType from '../Display/NatureType';
import OwnerType from '../Display/OwnerType';
import CategoryType from '../Display/CategoryType';
import TransactionKeyTag from '../Display/TransactionKeyTag';
import ShowAllTable from "./ShowAllTable";


class TransactionKeySettingTable extends React.Component {

  state = {
    showAll : false,
    calculateToDate : this.props.calculateToDate
  };

  constructor(props){
    super(props);
    this.showTableClick = this.showTableClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ calculateToDate: nextProps.calculateToDate });
  }

  showTableClick(showAll){
    this.setState({ showAll: showAll });
  };


  isTransactionKeyUsed(itemNumber, list){
    let item = list[itemNumber];

    let defaultKeys = ["000000", "101000", "102000", "102100", "110000" ];

    //check for payments
    for(let i = 0; i < this.props.data.payments.length; i++){
      let payment = this.props.data.payments[i];
      if (item.key === payment.transactionKey.key){
        return true;
      }
    }
    //check for cost
    for(let i = 0; i < this.props.data.costs.length; i++){
      let cost = this.props.data.costs[i];
      if (item.key === cost.transactionKey.key){
        return true;
      }
    }
    //check for returns
    for(let i = 0; i < this.props.data.returns.length; i++){
      let returnItem = this.props.data.returns[i];
      if (item.key === returnItem.transactionKey.key){
        return true;
      }
    }
    //defaultkeys
    for(let i = 0; i < defaultKeys.length; i++){
      if (item.key === defaultKeys[i]){
        return true;
      }
    }
    //some extra skil
    if (item.key.startsWith("9998")){
      return true;
    }

    return false;
  };


  render() {

    if (!this.props.data.transactionKeyTable){
      return (
        <div/>
      );
    }

    let transKeys = this.props.data.transactionKeyTable;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="9" className="text-left calc-setting-table-header">Færslulyklar</th>
          </tr>
          <tr>
            <th className="text-left">Lykill</th>
            <th className="text-left">Heiti</th>
            <th className="text-left">Eigandi</th>
            <th className="text-left">Tegund</th>
            <th className="text-left">Eðli</th>
            <th className="text-left">VSK</th>
            <th className="text-left">Vextir</th>
            <th className="text-left">Hópur</th>
            <th className="text-left">Heiti hóps</th>
          </tr>
          </thead>
          <tbody>
          {transKeys.map((item,i) => {
            let isUsed = this.isTransactionKeyUsed(i, transKeys);
            if ((!isUsed) && (!this.state.showAll)) {
              return;
            }

            let vatContent;
            let interestContent;
            if (item.calculateVat){
              vatContent = (
                <TransactionKeyTag color={'#ff00ff'} type={'V'} description={'VSK'}/>
              );
            }
            if (item.calculateInterest){
              interestContent = (
                <TransactionKeyTag color={'#ff0000'} type={'D'} description={'Dráttavextir'}/>
              );
            }

            let shouldHighlightClass = ((isUsed && this.state.showAll) ? "calc-setting-table-highlight" : "" );

            return(
              <tr className={shouldHighlightClass} key={i}>
                <td className="text-left">{item.key}</td>
                <td className="text-left">{item.name}</td>
                <td className="text-left"><OwnerType data={item.ownerType}/></td>
                <td className="text-left"><CategoryType data={item.categoryType}/></td>
                <td className="text-left"><NatureType data={item.natureType}/></td>
                <td className="text-left">{vatContent}</td>
                <td className="text-left">{interestContent}</td>
                <td className="text-left">{item.transactionGroup.groupKey}</td>
                <td className="text-left">{item.transactionGroup.name}</td>
              </tr>);
          })}
          </tbody>
        </table>
        <ShowAllTable showAll={this.state.showAll} numberOfColumns={9} handleShowHideClick={this.showTableClick}/>
      </div>
    );
  }
}

TransactionKeySettingTable.propTypes = {
    data: PropTypes.object,
    calculateToDate: PropTypes.object
};



export default TransactionKeySettingTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/TransactionKeySettingTable.js